import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {ArrowDownSquareFill} from "react-bootstrap-icons";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class DailyPerformance extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return `/report/daily-performance`;
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData(), dictionary = this.dictionary;

        const searchBarClassList = window.location.hash ? 'search-bar' : 'search-bar hidden';

        return (
            <>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['search']}
                        <span onClick={this.toggleSearchBar} style={{
                            cursor: 'pointer',
                            fontWeight: 'normal',
                            paddingLeft: '20px',
                            fontSize: '13px'
                        }}><ArrowDownSquareFill/> {this.dictionary.get['detailed-search']}</span>
                    </h5>

                    <form className="x-form" method="GET" onSubmit={this.handleSubmit}>
                        <div className={searchBarClassList}>
                            <div className="row">
                                {/*<div className="col-md-6 col-lg-4 col-xl-3">*/}
                                {/*    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>*/}
                                {/*</div>*/}
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{
                                        id: 'filter_from',
                                        defaultValue: params?.filter_from,
                                        type: 'date'
                                    }}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{
                                        id: 'filter_to',
                                        defaultValue: params?.filter_to,
                                        type: 'date'
                                    }}/>
                                </div>
                                {/*<div className="col-md-6 col-lg-4 col-xl-3">*/}
                                {/*    <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>*/}
                                {/*</div>*/}
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? '`x`.date:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/report/daily-performance/export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6 style={{width: '100%'}}>
                                    {this.dictionary.get['daily-performance']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="x.`date`">
                                    {this.dictionary.get['date']} <i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="imported_am"
                                    align={'right'}>{this.dictionary.get['imported_am']}</th>
                                <th className="sortable" data-sortkey="imported_pm"
                                    align={'right'}>{this.dictionary.get['imported_pm']}</th>
                                <th className="sortable" data-sortkey="imported_all_b2c"
                                    align={'right'}>{this.dictionary.get['imported_all_b2c']}</th>
                                <th className="sortable" data-sortkey="imported_all_b2b"
                                    align={'right'}>{this.dictionary.get['imported_all_b2b']}</th>
                                <th className="sortable" data-sortkey="imported_all"
                                    align={'right'}>{this.dictionary.get['imported_all']}</th>
                                <th className="sortable" data-sortkey="manifested_all_b2c"
                                    align={'right'}>{this.dictionary.get['manifested_all_b2c']}</th>
                                <th className="sortable" data-sortkey="manifested_all_b2b"
                                    align={'right'}>{this.dictionary.get['manifested_all_b2b']}</th>
                                <th className="sortable" data-sortkey="manifested_all"
                                    align={'right'}>{this.dictionary.get['manifested_all']}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={`dp-${elem.date}`} data-id={`dp-${elem.date}`}>
                                        <td>
                                            <DateTime value={elem.date} inline={true} onlydate={true}/>
                                            &nbsp; {dictionary.get[['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][new Date(elem.date).getDay()]]}
                                        </td>
                                        <td align={"right"}>
                                            {elem.imported_am ? <FormattedNumber value={elem.imported_am}
                                                                                 suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.imported_am_prod ? <FormattedNumber value={elem.imported_am_prod}
                                                                                             suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.imported_pm ?
                                            <FormattedNumber value={elem.imported_pm}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.imported_pm_prod ?
                                                <FormattedNumber value={elem.imported_pm_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.imported_all_b2c ?
                                            <FormattedNumber value={elem.imported_all_b2c}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.imported_all_b2c_prod ?
                                                <FormattedNumber value={elem.imported_all_b2c_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.imported_all_b2b ?
                                            <FormattedNumber value={elem.imported_all_b2b}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.imported_all_b2b_prod ?
                                                <FormattedNumber value={elem.imported_all_b2b_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.imported_all ?
                                            <FormattedNumber value={elem.imported_all}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.imported_all_prod ?
                                                <FormattedNumber value={elem.imported_all_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.manifested_all_b2c ?
                                            <FormattedNumber value={elem.manifested_all_b2c}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.manifested_all_b2c_prod ?
                                                <FormattedNumber value={elem.manifested_all_b2c_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.manifested_all_b2b ?
                                            <FormattedNumber value={elem.manifested_all_b2b}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.manifested_all_b2b_prod ?
                                                <FormattedNumber value={elem.manifested_all_b2b_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                        <td align={"right"}>{elem.manifested_all ?
                                            <FormattedNumber value={elem.manifested_all}
                                                             suffix={dictionary.get['pc']}/> : '-'}
                                            <br/>
                                            <small>{elem.manifested_all_prod ?
                                                <FormattedNumber value={elem.manifested_all_prod}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</small>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={5}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
